import { firestore } from "@/api/firebase/firebase.config";
import { GetUserProfileBasedOnUserSlug } from "../types/cloudFunctions/GetUserProfileBasedOnUserSlug";
import { Profile } from "@/models/database/profiles/profile.model";

export const fetchRecords = async (
  tenantId: string,
  slug: string,
  setUserProfile: (profile: GetUserProfileBasedOnUserSlug) => void,
  setLoading: (loading: boolean) => void,
  setError: (error: Error) => void
) => {
  try {
    const recordsRef = firestore
      .collection("profiles")
      .doc(tenantId)
      .collection("records")
      .where("slug", "==", slug.toLowerCase());

    const snapshot = await recordsRef.get();

    const record = snapshot.docs[0].data() as Profile;

    setUserProfile({
      ...record,
      belongsToCurrentUser: false,
      isFriendsOfCurrentUser: false,
      isFollowedByCurrentUser: false,
      gamesWithLinkedAccounts: [],
      isFriendsRequestPending: false,
      receivedFriendRequest: false,
    } as GetUserProfileBasedOnUserSlug);
  } catch (err) {
    setError(Error("Unable to find the user."));
  } finally {
    setLoading(false);
  }
};
